import React from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { LoginRoutes } from "config/LoginConfig";
import PageWrapper from "components/PageWrapper";
import {
  LoginPageLoader,
  SignUpPageLoader,
  ForgotPasswordPageLoader,
  ResetPasswordPageLoader,
  LogoutPageLoader,
  AddUserToOrganizationPageLoader,
  SmsMfaPageLoader,
  ConsentPageLoader,
} from "routes";
import { ErrorBoundary } from "./common/utils/errors";
import { AuthContextProvider } from "common/utils/context/AuthContext";
import { EmotionCache } from "common/utils/EmotionCache";

export const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <EmotionCache>
        <AuthContextProvider>
          <BrowserRouter>
            <PageWrapper>
              <Switch>
                <Route path={LoginRoutes.LANDING} exact component={LoginPageLoader} />
                <Route path={LoginRoutes.LOGIN} component={LoginPageLoader} />
                <Route path={LoginRoutes.NEW_SIGNUP} component={SignUpPageLoader} />
                <Route path={LoginRoutes.FORGOT_PASSWORD} component={ForgotPasswordPageLoader} />
                <Route path={LoginRoutes.RESET_PASSWORD} component={ResetPasswordPageLoader} />
                <Route path={LoginRoutes.LOGOUT} component={LogoutPageLoader} />
                <Route path={LoginRoutes.ADD_USER_TO_ORGANIZATION} component={AddUserToOrganizationPageLoader} />
                <Route path={LoginRoutes.SMS_MFA} component={SmsMfaPageLoader} />
                <Route path={LoginRoutes.CONSENT} component={ConsentPageLoader} />
                <Route path={LoginRoutes.SIGNUP} render={() => (window.location.href = "https://www.flexport.com/form/fulfillment-talk-to-us/")}/>
              </Switch>
            </PageWrapper>
          </BrowserRouter>
        </AuthContextProvider>
      </EmotionCache>
    </ErrorBoundary>
  );
};
